import React from 'react'
import styled, { css } from 'styled-components'

const width = '253'
const height = '539'
const viewBox = '0 0 253 539'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <g fill="#ffffff" id="g11" key={0} transform="matrix(-1,0,0,1,250.45495,0)">
      <path
        d="M 216.5,536.4 C 212.2,534.1 35.1,357 27.6,347.5 -2.5,309.1 -8.1,258.6 13,214.6 21.8,196.1 22.3,195.6 120.4,97.1 184,33.4 213.7,4.2 216.5,2.9 c 4.4,-2 11.9,-2.5 16.1,-0.9 1.5,0.6 6,4.3 10.1,8.2 l 7.4,7.2 -97.9,98.1 C 98.3,169.4 52.8,215.7 51,218.3 c -5.2,7.8 -10.8,20.8 -13.1,30.3 -4.3,17.6 -2.4,40.1 4.6,56 7.3,16.5 6,15.1 109.7,118.9 l 97.8,98 -7.2,7.2 c -4,4 -8.6,7.7 -10.1,8.2 -4.1,1.6 -12.7,1.3 -16.2,-0.5 z"
        id="path9"
      />
    </g>
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconFormArrowRight'
})
